import { render, staticRenderFns } from "./NormalForm.vue?vue&type=template&id=030420d6"
import script from "./NormalForm.vue?vue&type=script&lang=js"
export * from "./NormalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030420d6')) {
      api.createRecord('030420d6', component.options)
    } else {
      api.reload('030420d6', component.options)
    }
    module.hot.accept("./NormalForm.vue?vue&type=template&id=030420d6", function () {
      api.rerender('030420d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/additionalCharge/components/NormalForm.vue"
export default component.exports